export const environment = {
  production: true,

  version: '1.2.2',
  build: '250223.1106',

  appShellConfig: {
    debug: false,
    networkDelay: 500
  },

  configFile: './assets/config/app-config.json'
};
